// extracted by mini-css-extract-plugin
export default {"title":"Panelists_title__CXK3I","headers":"Panelists_headers__pxoQZ"};